import { useAboutPageSettingState } from './useApi/useAboutPageSetting';
import { useIsPageOwner } from './useIsPageOwner';
import { usePageOwnerIdentityStore } from '../store/pageOwnerIdentityStore';
import { canShowAboutPageSetting } from '../util/visibility/aboutVisibility';
import type { ResourceScope } from '../util/scopedResource';

export const useCanShowAboutPageSetting = (): boolean => {
  const isOwner = useIsPageOwner();
  const pageOwnerAui = usePageOwnerIdentityStore((state) => state.pageOwner?.aui);
  const { settingOwnerAui, settingScope, status } = useAboutPageSettingState();
  const currentScope: ResourceScope = isOwner ? 'owner' : 'public';

  return canShowAboutPageSetting({
    pageOwnerAui,
    settingOwnerAui,
    settingScope,
    currentScope,
    status,
  });
};
